import { HttpClient } from '@angular/common/http';
import { UrlService } from './url.service';
import { Observable } from 'rxjs';
import { TagEntitiesDto } from 'app/@types/dto/tag-entities-dto.model';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class TagHttpService {
    constructor(
        private http: HttpClient,
        private urlService: UrlService,
    ) {}

    getAll(orgId: string, entityId?: string): Observable<TagEntitiesDto[]> {
        return this.http.get<TagEntitiesDto[]>(this.urlService.getAllTagsOfOrgOrEntity(orgId, entityId));
    }

    create(tag: TagEntitiesDto, orgId: string): Observable<TagEntitiesDto[]> {
        return this.http.post<TagEntitiesDto[]>(this.urlService.createUpdateTagUrl(orgId), tag);
    }

    update(tag: TagEntitiesDto, orgId: string): Observable<TagEntitiesDto[]> {
        return this.http.put<TagEntitiesDto[]>(this.urlService.createUpdateTagUrl(orgId), tag);
    }

    delete(tagId: string, orgId: string): Observable<TagEntitiesDto[]> {
        return this.http.delete<TagEntitiesDto[]>(this.urlService.deleteTagUrl(orgId, tagId));
    }
}
